// Coliseu (documento de design): andares infinitos, monstros mais fortes e numerosos a cada andar, boss a cada 10.
// Sem XP nem drop; morte sem penalidade encerra a tentativa. 3 tentativas por dia (VIP 5), +3 compráveis (1 compra por dia).
// Ranking mensal por vocation e geral; recorde histórico à parte. Marcas compram recompensas próprias.
// Os valores de marcas, marcos e loja estavam em aberto no design: proposta abaixo.
export const COL_ATTEMPTS = { free: 3, vip: 5, buy: 3 } as const;
export const COL_BUY_PRICE = 50; // Noxara Coins por +3 tentativas (1 compra por dia)
export const COL_BOSS_EVERY = 10;

/** monstros por andar e multiplicadores de vida e dano */
export const colWave = (floor: number) => ({
  count: Math.min(14, 3 + Math.floor(floor / 3)),
  hp: 1 + floor * 0.06,
  dmg: 1 + floor * 0.04,
});
/** marcas por andar concluído */
export const colMarks = (floor: number) => Math.ceil(floor / 5);

/** marcos de primeira vez */
export const COL_MILESTONES: Array<{ floor: number; text: string; fragments?: number; marks?: number; aura?: string }> = [
  { floor: 10, text: '5 fragmentos de pedra de proteção', fragments: 5 },
  { floor: 25, text: '300 marcas do Coliseu', marks: 300 },
  { floor: 50, text: 'Aura do Gladiador e 10 fragmentos', aura: 'gladiador', fragments: 10 },
  { floor: 100, text: 'Aura do Campeão do Coliseu', aura: 'campeao' },
];

export interface ColShopItem { id: string; name: string; cost: number; desc: string; kind: 'fragment' | 'bestiary2x' | 'aura'; amount: number; aura?: string }
export const COL_SHOP: ColShopItem[] = [
  { id: 'frag', name: 'Fragmento de pedra de proteção', cost: 60, kind: 'fragment', amount: 1, desc: 'Para o refine (10 formam uma pedra).' },
  { id: 'best', name: 'Poção do Bestiário (2 h)', cost: 150, kind: 'bestiary2x', amount: 120, desc: 'Os abates contam em dobro no bestiário por 2 horas de jogo.' },
  { id: 'aura-g', name: 'Aura do Gladiador', cost: 2500, kind: 'aura', amount: 1, aura: 'gladiador', desc: 'Cosmético exclusivo do Coliseu.' },
];

/** modificadores da temporada (como no Tibiadrome): 2 sorteados por mês entre estes */
export const COL_MODIFIERS: Array<{ id: string; name: string; desc: string }> = [
  { id: 'fury', name: 'Fúria', desc: 'Monstros causam +20% de dano.' },
  { id: 'iron', name: 'Pele de Ferro', desc: 'Monstros têm +25% de vida.' },
  { id: 'swarm', name: 'Enxame', desc: '+2 monstros por andar.' },
  { id: 'haste', name: 'Pressa', desc: 'Monstros andam 30% mais rápido.' },
  { id: 'glass', name: 'Vidro', desc: 'Monstros têm −20% de vida, mas causam +35% de dano.' },
  { id: 'elite', name: 'Elite', desc: 'O boss surge a cada 5 andares.' },
];
export function colSeason(month: string): string[] {
  let h = 7; for (const ch of month) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  const a = h % COL_MODIFIERS.length, b = (a + 1 + (h >> 8) % (COL_MODIFIERS.length - 1)) % COL_MODIFIERS.length;
  return [COL_MODIFIERS[a]!.id, COL_MODIFIERS[b]!.id];
}
